import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "title": "مسارات التعلم",
  "lead": "برغم أن أغلب الأطفال يقضون الآن سنوات عديدة في المدرسة، إلا أنهم غالبًا ما يخرجون منها دون حتى المهارات الأساسية للقراءة والرياضيات. تظهر مسارات التعلم مقدار ما يتعلمه الأطفال أثناء تقدمهم في المدرسة. ويمكنها أن تساعدنا على فهم العملية التي تسفر عن انخفاض معدل التعلم، ومتى وكيف نتدخل أثناء هذه العملية، وما التأثير المحاكي للسياسات المختلفة على التحدي العاجل المتمثل في تدني مستوى التعلم."
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    blockquote: "blockquote",
    h2: "h2",
    h3: "h3",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {Explorer, Figure, HighlightByIndex, IndicatorReference, RelatedMaterial, ScrollyArea, ScrollySection, ScrollyStep, ScrollySticky, SimulationsTab, TrajectoriesTab} = _components;
  if (!Explorer) _missingMdxReference("Explorer", true);
  if (!Figure) _missingMdxReference("Figure", true);
  if (!HighlightByIndex) _missingMdxReference("HighlightByIndex", true);
  if (!IndicatorReference) _missingMdxReference("IndicatorReference", true);
  if (!RelatedMaterial) _missingMdxReference("RelatedMaterial", true);
  if (!ScrollyArea) _missingMdxReference("ScrollyArea", true);
  if (!ScrollySection) _missingMdxReference("ScrollySection", true);
  if (!ScrollyStep) _missingMdxReference("ScrollyStep", true);
  if (!ScrollySticky) _missingMdxReference("ScrollySticky", true);
  if (!SimulationsTab) _missingMdxReference("SimulationsTab", true);
  if (!TrajectoriesTab) _missingMdxReference("TrajectoriesTab", true);
  return _jsxs(_Fragment, {
    children: [_jsx(Figure, {
      id: "HERO_LEARNING"
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsx(_components.p, {
        children: "تظهر مسارات التعلم عدد السنوات أو الصفوف الدراسية التي يستغرقها الأطفال لاكتساب المهارات الأساسية. وبما أن هذه المسارات تتبع وتيرة التعلم في النظام، فإنها يمكن أن تساعدنا على فهم عدد الأطفال الذين يكافحون من أجل اكتساب هذه المهارات، ومتى وكيف نتدخل، وكيف يمكن للسياسات المختلفة أن تؤثر على التحدي المُلح المتمثل في تدني مستوى التعلم."
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "ماذا-يمكن-أن-تخبرنا-مسارات-التعلم",
      children: "ماذا يمكن أن تخبرنا مسارات التعلم؟"
    }), "\n", _jsx(_components.p, {
      children: "من الناحية المثالية، تكون مسارات التعلم شديدة الانحدار. ومع ذلك، فإننا نرى في كثير من الأحيان مسارات التعلم المسطحة، مما يشير إلى بطء وتيرة التعلم. إن البداية البطيئة قد يكون لها عواقب طويلة الأمد. ويرجع ذلك إلى أن الأطفال عندما يتخلفون عن الركب، فإن المنهج الدراسي غالبًا ما ينتقل إلى مواد أكثر تقدمًا، والتي يفتقرون إلى المهارات الأساسية اللازمة للتعامل معها."
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "تكشف مسارات التعلم في العديد من البلدان أن وتيرة التعلم بطيئة للغاية، وأن هذا يعبر عن الحقيقة منذ اللحظة الأولى في الدراسة."
      }), " في الصف الأول والثاني، عندما تفترض الأهداف العالمية والعديد من المناهج الوطنية أن الأطفال يتعلمون القراءة، فإن أقلية صغيرة فقط من الأطفال يفعلون ذلك بالفعل."]
    }), "\n", _jsx(IndicatorReference, {
      id: "4.1.1",
      label: "4.1.1a",
      children: _jsxs(_components.p, {
        children: ["وتشكل هذه المهارات، التي يتم قياسها في الجولة السادسة من مسوحات اليونيسيف العنقودية المتعددة المؤشرات (MICS6)، المتطلبات الأساسية للتعلم في المستقبل، ويتم قياسها هنا من خلال ما إذا كان الأطفال قادرين على قراءة قصة بسيطة من 70 كلمة بصوت عالٍ (على سبيل المثال \"مانه في الصف الثاني\") والإجابة على خمسة أسئلة بسيطة عنها (على سبيل المثال \"في أي صف يوجد مانه؟\"). تكون هذه المهارات الأساسية عادةً أقل من مستوى الكفاءة الأدنى الذي حدده ", _jsx(_components.a, {
          href: "https://sdgs.un.org/goals/goal4",
          children: "المؤشر العالمي 4.1.1 (أ) من أهداف التنمية المستدامة"
        }), ". وبالتالي، فإن المسارات المحسوبة تبالغ في تقدير التقدم المحرز نحو تحقيق الهدف 4.1.1 (أ)، ولكنها تظل تقديرات مفيدة لتوضيح وتيرة التعلم."]
      })
    }), "\n", _jsxs(ScrollyArea, {
      children: [_jsx(ScrollySticky, {
        children: _jsx(Figure, {
          id: "TRAJECTORIES_CURRENT"
        })
      }), _jsx(ScrollySection, {
        id: "HIGHLIGHT_VIETNAM",
        children: _jsxs(_components.p, {
          children: [_jsx(HighlightByIndex, {
            index: "2",
            children: "إن فيتنام"
          }), " مثال جيد على\nمسار بلد يتمتع بأداء مرتفع نسبيًا. خلال الصفوف الدراسية الأولية\nفي المدارس، يتعلم معظم الأطفال في فيتنام مهارات القراءة الأساسية."]
        })
      }), _jsx(ScrollySection, {
        id: "LMIC_GRADE_3",
        children: _jsxs(_components.p, {
          children: ["مسار التعلم في العديد من البلدان الأخرى", " ", "\n", _jsx(HighlightByIndex, {
            index: "4",
            children: "ذات الدخول المنخفضة والمتوسطة المنخفضة"
          }), " ", "\nأكثر تسطيحًا بكثير. طفل واحد فقط من بين كل أربعة أطفال في البلد العادي\nيتعلم حاليًا مهارات القراءة الأساسية بحلول الصف الثالث."]
        })
      }), _jsx(ScrollySection, {
        id: "LMIC_GRADE_6",
        children: _jsxs(_components.p, {
          children: ["يستمر انخفاض مستوى التعلم مع استمرار الأطفال في الدراسة بالمدرسة. لقد اكتسب ما يزيد قليلًا عن\nنصف طلاب الصف السادس في", " ", "\n", _jsx(HighlightByIndex, {
            index: "4",
            children: "البلدان ذات الدخول المنخفضة والمتوسطة"
          }), " ", "\nفي مجموعة البيانات ما يعتبر عادةً مهارات القراءة التي يحتاجها الصف الثاني\nوالثالث."]
        })
      }), _jsx(ScrollySection, {
        id: "DIFFERENCE_TRAJECTORIES",
        children: _jsx(_components.p, {
          children: "ومع ذلك، فإن المسار المتوسط يخفي أوجه الفرق بين البلدان. في أي مكان،\nيستطيع ما بين 3% و76% من الأطفال في البلدان\nالمنخفضة والمتوسطة الدخول المدرجة في مجموعة البيانات القراءة بحلول الصف الثالث. وهذا يدل على\nأن البلدان التي تلتزم بتحسين التعلم الأساسي يمكنها القيام بذلك،\nحتى عند مستويات متدنية نسبيًا من الدخل القومي."
        })
      }), _jsx(ScrollyStep, {
        id: "default"
      })]
    }), "\n", _jsx(_components.p, {
      children: "بالنسبة لبلد يريد التصدي لمشكلة تدني مستوى التعلم، فإن السياسات المتبعة هي:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "قياس ومنح الأولوية للمهارات الأساسية، بدءًا من الصفوف المبكرة."
      }), "\n", _jsx(_components.li, {
        children: "توفيق الإرشاد مع وتيرة التعلم الفعلية للأطفال. ويمكن القيام بذلك بعدة طرق، بما في ذلك تحديد أهداف تعليمية واضحة تركز على التعلم الأساسي، وتعديل وتيرة المناهج الدراسية، ودعم المعلمين لفهم أسلوب تدريسهم وتكييفه مع مستويات التعلم الحالية للأطفال."
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "محاكاة-السياسات-الوصول-والتعلم",
      children: "محاكاة السياسات: الوصول والتعلم"
    }), "\n", _jsx(_components.p, {
      children: "يمكننا استخدام مسارات التعلم لمقارنة التأثير المحتمل لمختلف السياسات. وهنا نقوم بمحاكاة تأثير السياسات التي تهدف إلى زيادة فرص الوصول والنهوض بالتعلم. ترنو السياسات الموجهة نحو الوصول إلى زيادة عدد السنوات التي يقضيها الأطفال في المدرسة. ويشمل ذلك سياسات مثل مجانية التعليم الابتدائي والثانوي، وبناء المدارس، والترويج التلقائي، وغيرها من السياسات التي تركز في المقام الأول على الالتحاق أو التحصيل الدراسي. تسعى السياسات الموجهة نحو التعلم إلى زيادة مقدار ما يتعلمه الأطفال في كل مرحلة دراسية. وتشمل أمثلة هذه السياسات تحديد وقياس التقدم المحرز في ضوء أهداف التعلم الجلية، وإعادة تنظيم التعليم بما يتناسب مع وتيرة تعلم الأطفال، ودعم التدريس الفعال."
    }), "\n", _jsxs(_components.p, {
      children: ["يجب أن يتمتع كل طفل بالقدرة على الوصول إلى المدرسة، ويعد إرسال الأطفال إلى المدرسة خطوة أولى ضرورية نحو التعلم الشامل. ومع ذلك، تظهر هذه المحاكاة أن المزيد من ", _jsx(HighlightByIndex, {
        index: "2",
        children: "الزيادات في إمكانية الوصول"
      }), " لن تفعل بمفردها الكثير لمعالجة عملية التعلم. وعلى النقيض من ذلك، يمكن تحقيق مكاسب محتملة طائلة من خلال ", _jsx(HighlightByIndex, {
        index: "3",
        children: "النهوض بمستوى التعلم في كل صف دراسي"
      }), " لمواكبة وتيرة التعلم في البلدان ذات الدخول المنخفضة والمتوسطة المنخفضة ذات الأداء الأعلى."]
    }), "\n", _jsxs(ScrollyArea, {
      children: [_jsx(ScrollySticky, {
        children: _jsx(Figure, {
          id: "TRAJECTORIES_SIMULATION_LMIC"
        })
      }), _jsx(ScrollySection, {
        id: "COMPARISON",
        children: _jsx(_components.p, {
          children: "إن الفارق في الأداء بين البلدان ذات الأداء المنخفض والبلدان ذات الأداء المرتفع\nيكون مدفوعًا بتوفير قدر أكبر من الوصول إلى المدارس، وعلى وجه الخصوص،\nتمكين الأطفال من التعلم أكثر في كل صف دراسي."
        })
      }), _jsx(ScrollySection, {
        id: "FADED",
        children: _jsx(_components.p, {
          children: "تظهر هذه المحاكاة المسارات حسب العمر. وهي تشمل كلًا من الأطفال داخل\nالمدرسة وخارجها. نظرًا لأن الأطفال غير الملتحقين بالمدارس يميلون إلى تحقيق مستوى أقل من التعلم،\nفإن مسارات التعلم هذه أكثر تسطحًا من تلك التي تختلف حسب الصف."
        })
      }), _jsx(ScrollySection, {
        id: "CURRENT",
        children: _jsxs(_components.p, {
          children: ["في المتوسط عبر خمس دول", " ", "\n", _jsx(HighlightByIndex, {
            index: "4",
            children: "البلدان ذات الدخول المنخفضة والمتوسطة"
          }), " ", "\nفإن نسبة 8% فقط من الأطفال في سن التاسعة يستطيعون القراءة بمستوى مناسب\nلأعمارهم."]
        })
      }), _jsx(ScrollySection, {
        id: "SIMULATION_ACCESS",
        children: _jsxs(_components.p, {
          children: ["تقترب ", _jsx(HighlightByIndex, {
            index: "2",
            children: "محاكاة الوصول"
          }), " ", "\nمما قد يحدث إذا كان جميع الأطفال في المدرسة. ويتم ذلك\nمن خلال تقدير ما يمكن أن يحدث إذا حصل جميع الأطفال الذين لم يلتحقوا بالمدرسة مطلقًا،\nأو الذين تركوا الدراسة، بدلًا من ذلك على نفس متوسط الدرجات\nومستوى التعلم مثل أقرانهم في المدرسة من نفس الفئة العمرية. في نفس البلدان الخمسة\nذات الأداء المنخفض، تشير المحاكاة إلى أن هذا من شأنه أن يزيد\nعدد الأطفال في سن التاسعة الذين يستطيعون القراءة بنسبة 1%."]
        })
      }), _jsx(ScrollySection, {
        id: "SIMULATION_LEARNING",
        children: _jsxs(_components.p, {
          children: ["إذا استمر الأطفال في سن التاسعة في هذه البلدان في الوصول إلى نفس الصف الذي يصلون إليه\nالآن، ولكن بدلًا من ذلك", " ", "\n", _jsx(HighlightByIndex, {
            index: "3",
            children: "يتعلمون نفس القدر في كل صف دراسي"
          }), "مثل\nالأطفال في البلدان الخمسة الأعلى أداءً في البلدان المنخفضة والمتوسطة الدخول،\nفقد يتمكن 43% منهم من القراءة - بزيادة قدرها\n35 نقطة مئوية."]
        })
      }), _jsx(ScrollyStep, {
        id: "default"
      })]
    }), "\n", _jsx(_components.h2, {
      id: "محاكاة-السياسات-المساواة",
      children: "محاكاة السياسات: المساواة"
    }), "\n", _jsx(_components.p, {
      children: "وتُعد مسارات التعلم أيضًا أداة قوية لفهم الاختلافات في التعلم بين المجموعات داخل البلدان. ونحن هنا بصدد مقارنة مستوى التعلم بين الأغنياء والفقراء، ونقوم بمحاكاة تأثير السياسات التي تحاول الحد من التفاوت بينهم."
    }), "\n", _jsxs(_components.p, {
      children: ["في المتوسط عبر جميع البلدان المنخفضة والمتوسطة الدخول المنخفضة في مجموعة البيانات، فإن أطفال الأثرياء (ثروة الأسرة في أعلى 20%) يذهبون إلى المدرسة أكثر، ويتعلمون أكثر في كل صف دراسي، بالمقارنة بأطفال الفقراء (ثروة الأسرة في أدنى 20%). تظهر ", _jsx(HighlightByIndex, {
        index: "2",
        children: "محاكاة الوصول المتساوي"
      }), " ما قد يحدث إذا حصل الفقراء على قدر من التعليم يساوي ما يحصل عليه الأغنياء، في حين تظهر ", _jsx(HighlightByIndex, {
        index: "3",
        children: "محاكاة التعلم المتساوي"
      }), " ما قد يحدث إذا تعلم الفقراء في كل صف دراسي نفس القدر الذي يتعلمه الأغنياء. وفي كلا السيناريوهين، وخصوصًا في محاكاة التعلم المتساوي، سوف تنخفض مستويات عدم المساواة."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "ومع ذلك، حتى أطفال الأغنياء لا يحصلون على تعليم جيد جدًا"
      }), ". إن ما يقرب من نصف أطفال الأثرياء يفشلون في اكتساب مهارات القراءة الأساسية، مما يضع حدًا للتأثير المحتمل للسياسات الموجهة نحو المساواة. وتؤدي عمليات محاكاة التكافؤ بين الأولاد والبنات، أو بين أطفال المناطق الحضرية والريفية، إلى مكاسب أقل حجمًا."]
    }), "\n", _jsxs(_components.p, {
      children: ["بالنسبة لبلد يريد معالجة مشكلة تدني مستوى التعلم، فإن النتيجة السياسية هي أن سد الفجوات بين المجموعات داخل البلدان لا يشكل سوى جزء من الحل. ", _jsx(_components.strong, {
        children: "وثمة تحدٍ آخر ملحٍ يتمثل في إجراء تغييرات منهجية تعمل على النهوض بالتعلم لجميع الأطفال ــ الأغنياء والفقراء، الأولاد والبنات، في المناطق الحضرية والريفية ــ لتحقيق الانتقال من نظام منخفض الأداء إلى نظام عالي الأداء."
      })]
    }), "\n", _jsxs(ScrollyArea, {
      children: [_jsx(ScrollySticky, {
        children: _jsx(Figure, {
          id: "TRAJECTORIES_SIMULATION_EQUALITY"
        })
      }), _jsx(ScrollySection, {
        id: "CURRENT",
        children: _jsxs(_components.p, {
          children: ["إن أطفال ", _jsx(HighlightByIndex, {
            index: "4",
            children: "الفقراء"
          }), " يسلكون\nمسارًا تعليميًا أدنى من أطفال الأغنياء. بمتوسط\n23 دولة من الدول ذات الدخول المنخفضة والمتوسطة المنخفضة، فإن 19% فقط من\nأطفال الأسر الفقيرة لديهم مهارات القراءة الأساسية بحلول سن التاسعة."]
        })
      }), _jsx(ScrollySection, {
        id: "SIMULATION_ACCESS",
        children: _jsxs(_components.p, {
          children: ["إن ", _jsx(HighlightByIndex, {
            index: "2",
            children: "المحاكاة الأولى"
          }), " تظهر\nماذا قد يحدث إذا حصل أطفال الأسر الفقيرة على نفس القدر من التعليم الذي يحصل عليه\nأطفال الأسر الغنية (من حيث التحصيل الدراسي حسب العمر). بمتوسط\n23 دولة، فإن هذا من شأنه أن يرفع مهارات القراءة الأساسية بنسبة 4 نقاط\nمئوية فقط في سن التاسعة."]
        })
      }), _jsx(ScrollySection, {
        id: "SIMULATION_LEARNING",
        children: _jsxs(_components.p, {
          children: ["إن ", _jsx(HighlightByIndex, {
            index: "3",
            children: "المحاكاة الثانية"
          }), " تظهر\nماذا قد يحدث إذا حافظ أطفال الأسر الفقيرة على مستواهم الحالي\nمن التعليم (أي أنهم حضروا نفس الصف الدراسي الذي يحصلون عليه الآن) ولكنهم تعلموا\nفي كل صف دراسي نفس القدر الذي يتعلمه أطفال الأسر الغنية. على الأرجح قد يؤدي هذا إلى\nزيادة مهارات القراءة الأساسية لديهم بنسبة 17 نقطة مئوية في سن\nالتاسعة."]
        })
      }), _jsx(ScrollySection, {
        id: "COMPARISON",
        children: _jsx(_components.p, {
          children: "إذا حصل أطفال الفقراء على نفس القدر من التعليم وتعلموا\nمثل أطفال الأغنياء (أي إذا كان للفقراء نفس المسار الذي سلكه الأغنياء)\nفإن مهارات القراءة الأساسية لأطفال الفقراء قد ترتفع بنسبة 29 نقطة\nمئوية فقط في سن التاسعة."
        })
      }), _jsx(ScrollySection, {
        id: "COMPARISON_GROUP",
        children: _jsx(_components.p, {
          children: "ومع ذلك، فإن هذا من شأنه أن يترك ما يقرب من نصف الأطفال دون المهارات\nالأساسية للقراءة. حتى أطفال العائلات الغنية لا يحصلون على تعليم\nجيد النوعية في العديد من البلدان."
        })
      }), _jsx(ScrollyStep, {
        id: "default"
      })]
    }), "\n", _jsx(_components.h2, {
      id: "إنشاء-مسارات-التعلم-ومحاكاة-السياسات-الخاصة-بك",
      children: "إنشاء مسارات التعلم ومحاكاة السياسات الخاصة بك"
    }), "\n", _jsx(_components.p, {
      children: "فيما يلي أداة لإنشاء مسارات التعلم الخاصة بك وتشغيل محاكاة السياسات. بمقدورك استكشاف البيانات من بلدان متعددة لكل من المهارات الأساسية للقراءة والرياضيات."
    }), "\n", _jsxs(_components.p, {
      children: ["كتذكير، يتم قياس مهارات القراءة من خلال قدرة الأطفال على قراءة قصة بسيطة مكونة من 70 كلمة بصوت جهوري والإجابة عن خمسة أسئلة بسيطة حول القصة. يتم قياس مهارات الرياضيات على أربعة مجالات (تحديد الأرقام، وتمييز الأرقام، والجمع البسيط، وأنماط الأرقام) باستخدام 21 سؤالًا بسيطًا. ويعتبر الطفل قد أتقن مهارات القراءة والرياضيات الأساسية هذه إذا أجاب عن جميع الأسئلة بشكل صحيح. هذه عادةً مهارات من المستوى الثاني أو الثالث وهي أقل من مستوى الكفاءة الأدنى المحدد بواسطة ", _jsx(_components.a, {
        href: "https://sdgs.un.org/goals/goal4",
        children: "مؤشر التنمية المستدامة العالمي 4.1.1أ"
      }), "."]
    }), "\n", _jsxs(Explorer, {
      children: [_jsx(TrajectoriesTab, {
        children: _jsx(_components.p, {
          children: "تتنوع مسارات التعلم بشكل كبير عبر السياقات. تتيح لك هذه الأداة\nبناء ومقارنة وتصدير المسارات الأكثر ملاءمة لك.\nيمكنك تصور ومقارنة مسارات البلدان المختلفة، أو\nيمكنك بناء ومقارنة مسارات المجموعات داخل بلد ما."
        })
      }), _jsx(SimulationsTab, {
        children: _jsx(_components.p, {
          children: "تتيح لك هذه الأدوات تشغيل عمليات محاكاة السياسات وتحليل النتائج\nلإعلام أولويات السياسات. يمكنك إجراء محاكاة للسياسات على مستوى\nالدولة؛ حيث يمكنك تقدير تأثير تحقيق التعليم الشامل\nوتحقيق التعلم لكل صف دراسي في بلد المقارنة. يمكنك أيضًا إجراء\nمحاكاة للسياسات لمجموعات داخل بلد ما؛ حيث يمكنك\nمحاكاة التأثير الذي قد يحدث إذا كان لدى مجموعتين سكانيتين نفس\nمعدلات التحصيل الدراسي والتعلم."
        })
      })]
    }), "\n", _jsx(_components.h2, {
      id: "خاتمة",
      children: "خاتمة"
    }), "\n", _jsx(_components.p, {
      children: "تكشف مسارات التعلم عن مدى سرعة اكتساب الأطفال لمهارات التعلم الأساسية. وهي تشكل أداة مهمة يمكن استخدامها لرفع مستوى الوعي العام بشأن تدني نتائج التعلم ومساعدة صناع السياسات في التخطيط لكيفية اتخاذ الإجراءات اللازمة."
    }), "\n", _jsx(_components.h3, {
      id: "الشكر-والتقدير",
      children: "الشكر والتقدير"
    }), "\n", _jsxs(_components.p, {
      children: ["تم إنشاء محتوى هذه الصفحة الإلكترونية بواسطة برنامج ", _jsx(_components.a, {
        href: "http://riseprogramme.org/",
        children: "RISE (البحث في تحسين أنظمة التعليم)"
      }), " - برنامج أبحاث أنظمة التعليم واسعة النطاق المدعوم بتمويل من [وزارة الخارجية وشؤون الكومنولث والتنمية في المملكة المتحدة (FCDO)](https://www.gov.uk/ Government/organisations/foreign-commonwealth-development-office)، وزارة الشؤون الخارجية والتجارة الأسترالية (DFAT)http://dfat.gov.au)، و", _jsx(_components.a, {
        href: "https://www.gatesfoundation.org",
        children: "مؤسسة بيل وميليندا جيتس"
      }), ". تتم إدارة البرنامج وتنفيذه من خلال شراكة بين ", _jsx(_components.a, {
        href: "https://www.opml.co.uk",
        children: "إدارة سياسات أكسفورد"
      }), " و", _jsx(_components.a, {
        href: "http://bsg.ox.ac.uk",
        children: "مدرسة بلافاتنيك للحكم في جامعة أكسفورد"
      }), "."]
    }), "\n", _jsx(RelatedMaterial, {
      children: _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://riseprogramme.org/tools/learning-trajectories",
            children: "Learning trajectories resources – RISE (مصادر مسارات التعلم – برنامج RISE)"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://data.unicef.org/resources/are-children-really-learning-foundational-skills-report/",
            children: "Are Children Really Learning? (هل يتعلم الأطفال حقًا؟) Exploring foundational skills in the midst of a learning crisis – UNICEF 2022 (استكشاف المهارات الأساسية في خضم أزمة التعلم – اليونيسيف 2022)"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://www.sciencedirect.com/journal/international-journal-of-educational-development/special-issue/1035CNWP9N3",
            children: "Special issue on learning profiles (open source) – International Journal of Educational Development (IJED) عدد خاص عن ملفات التعلم (مفتوح المصدر) - المجلة الدولية للتنمية التعليمية (IJED)"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://mics.unicef.org/files?job=W1siZiIsIjIwMjAvMDUvMTIvMTgvMjUvNDUvNzAxLzIwXzA1XzA4X01JQ1NfR3VpZGVib29rX2NvbXByZXNzZWQucGRmIl1d&sha=6d386818d588d05c",
            children: "How to analyze MICS6 education data - UNICEF (كيفية تحليل بيانات التعليم الخاصة بالمسح العنقودي المتعدد المؤشرات السادس - اليونيسيف)"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://riseprogramme.org/publications/descriptive-learning-trajectories-and-policy-simulations-using-mics6-data",
            children: "Simulations methodology – RISE (منهجية المحاكاة – برنامج RISE)"
          })
        }), "\n"]
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
